/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

document.addEventListener("DOMContentLoaded", function () {
  const link = document.querySelector('.callout-a a');

  if (link) {
    const avaDiv = document.createElement("div");
    avaDiv.className = "AskAva-cta";
    avaDiv.setAttribute("data-product", "creditTool");
    avaDiv.setAttribute("data-type", "button");

    link.replaceWith(avaDiv);
  }
});
